<template>
  <div class="info-container content-bg" :class="{
    isMobile: isMobile()
  }">
    <commonTop
      :moduleData="moduleData"
    />

    <div class="common-line-box sys-max-width">
      <!-- mobile -->
      <div class="content lg-mx" v-if="isMobile()">
        <div class="top">
          <el-menu
            mode="horizontal"
            class="el-menu-box"
            :default-active="menuActive"
            @select="menuSelect"
          >
            <el-menu-item v-for="item in moduleSecondList" :key="item.id" :index="item.id">
              <span slot="title">{{ item.name }}</span>
            </el-menu-item>
          </el-menu>
        </div>

        <div class="bottom">
          <router-view />
        </div>
      </div>

      <!-- pc -->
      <div class="content flex" v-else>
        <div class="left">
          <el-menu
            class="el-menu-box"
            :default-active="menuActive"
            @select="menuSelect"
          >
            <el-menu-item v-for="item in moduleSecondList" :key="item.id" :index="item.id">
              <span slot="title">{{ item.name }}</span>
            </el-menu-item>
          </el-menu>
        </div>

        <div class="right">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isMobile } from '@/utils/index'
import { MODULE_CONFIG } from '@/config/index'
import moduleMixins from '@/mixins/module'

export default {
  mixins: [moduleMixins],

  data() {
    return {
      moduleId: MODULE_CONFIG.INFO,

      menuActive: ''
    }
  },

  watch: {
    moduleSecondList(newVal) {
      const { name } = this.$route

      if (name === 'info') { // 直接跳转到列表
        this.goInfoDetail(newVal)
      }
    },
    $route(newVal) {
      console.log(newVal)
      const { name, params } = newVal

      if (name === 'info-detail') { // 详情
        this.menuActive = params.id
      }
    }
  },

  methods: {
    isMobile,
    menuSelect(index) {
      this.menuActive = index

      this.$router.push({
        name: 'info-detail',
        params: {
          id: index
        }
      })
    },

    goInfoDetail(arr) {
      if (Array.isArray(arr) && arr.length > 0) {
        const targetId = arr[0].id
        this.menuActive = targetId

        this.$router.push({
          name: 'info-detail',
          params: {
            id: targetId
          }
        })
      }
    }
  },

  created() {
    const { name, params } = this.$route

    if (name === 'info-detail') { // 详情
      this.menuActive = params.id
    } else {
      this.goInfoDetail(this.moduleSecondList)
    }
  }
}
</script>

<style lang="scss">
.info-container {


  &.isMobile {
    .common-line-box {
      .content {
        border-radius: 0;
      }
    }
  }

  .common-line-box {


    .content {


      .left {

      }

      .right {

      }
    }
  }
}
</style>
